import {tagTypeAction, tagTypeAPI} from './constants';

const modifiedTag = (entities, tagModified) => {
	const newStateEntities = entities.map((entity) => {
		return {
			...entity,
			contacts: entity.contacts.map((contact) => {
				if (tagModified.operationType === tagTypeAPI[tagTypeAction.edit]) {
					if (contact.tags.some((tag) => tag.id === tagModified.id)) {
						const newTags = contact.tags.map((tag) => {
							if (tag.id === tagModified.id) {
								return {...tag, name: tagModified.name, color: tagModified.color};
							} else {
								return {...tag};
							}
						});
						return {...contact, tags: [...newTags]};
					} else {
						return {...contact};
					}
				} else if (tagModified.operationType === tagTypeAPI[tagTypeAction.delete]) {
					const newTags = contact.tags.filter((tag) => tag.id !== tagModified.id);
					return {...contact, tags: [...newTags]};
				} else {
					return {...contact};
				}
			})
		};
	});

	return [...newStateEntities];
};

export default (entities, actionArray) => {
	let newEntities = [...entities];
	actionArray.forEach((tagModified) => {
		newEntities = modifiedTag(newEntities, tagModified);
	});
	return [...newEntities];
};
